export const selectOnboardingState = (state) => state['onboarding']

export const selectOnboardingStatus = (state) => selectOnboardingState(state).status

export const selectIsOnboardingRunning = (state) => selectOnboardingStatus(state) === 'running'

const PAYMENT_PROFILE_MODERATION_STATUSES = ['new', 'pending']

const EMPTY_FORM_VALUES = {}

export const selectBillingFormValues = (form = {}) =>
  form?.billing?.values || form?.values || EMPTY_FORM_VALUES

export const selectIsPaymentProfileOnModeration = (
  paymentProfiles = [],
  paymentProfileId = null,
) => {
  if (!paymentProfileId) return false

  const selectedPaymentProfile = paymentProfiles.find(
    ({ id }) => String(id) === String(paymentProfileId),
  )

  return PAYMENT_PROFILE_MODERATION_STATUSES.includes(
    String(selectedPaymentProfile?.status || '').toLowerCase(),
  )
}
